import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";

import { useAuth } from "../../contexts/AuthContext";
import authService from "../../services/auth/authService";

import "./Login.css";

export default function Login() {

    const navigate = useNavigate();

    const { login } = useAuth();

    const [formData, setFormData] = useState({

        userName: "",

        password: ""

    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {

        setFormData({

            ...formData,

            [e.target.name]: e.target.value

        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!formData.userName.trim()) {

            toast.error("Username is required.");

            return;

        }

        if (!formData.password.trim()) {

            toast.error("Password is required.");

            return;

        }

        try {

            setLoading(true);

            const response = await authService.login(formData);

            if (response.success) {

                login(response.data);

                toast.success(response.message);

                navigate("/dashboard");

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            toast.error(

                error.response?.data?.message ||

                "Login failed."

            );

        }
        finally {

            setLoading(false);

        }

    };

    return (

        <div className="login-page">

            <div className="login-left">

                <div className="login-card">

                    <h2 className="mb-4">
                        Website Admin Panel
                    </h2>

                    <form onSubmit={handleSubmit}>

                        <div className="mb-3">

                            <label className="form-label">
                                Username
                            </label>

                            <input
                                type="text"
                                name="userName"
                                className="form-control"
                                value={formData.userName}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="mb-4">

                            <label className="form-label">
                                Password
                            </label>

                            <input
                                type="password"
                                name="password"
                                className="form-control"
                                value={formData.password}
                                onChange={handleChange}
                            />

                        </div>

                        <button
                            className="btn btn-primary w-100"
                            disabled={loading}
                        >

                            {loading
                                ? "Signing In..."
                                : "Login"}

                        </button>

                    </form>

                </div>

            </div>

            <div className="login-right">

                <div className="overlay">

                    <h1>Welcome Back</h1>

                    <p>Website Admin Panel</p>

                </div>

            </div>

        </div>

    );

}